import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// // SOURCETYPES
export const sourcetypeCreate = (params = '') => Http.post('/vacancies-salary-source-types', params)
// // // LIST ALL SOURCETYPES
export const sourcetypesList = (params = '') => Http.get(`/vacancies-salary-source-types${serialize(params)}`)
// // // GET SOURCETYPE BY ID
export const sourcetypeByID = (params = '') => Http.get(`/vacancies-salary-source-types/${params}`)
// // // UPDATE SOURCETYPE
export const sourcetypeUpdate = (params = '') => Http.put(`/vacancies-salary-source-types/${params.id}`, params)
// // // DELETE SOURCETYPE
export const sourcetypeDestroy = (params = '') => Http.delete(`/vacancies-salary-source-types/${params.id}`)
